"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      width: '100%'
    },
    navButton: {
      cursor: 'pointer',
      opacity: 0,
      zIndex: 1,
      padding: 0,
      outline: 'none',
      border: 'none',
      background: 'transparent',
      position: 'absolute',
      top: 0,
      height: '100%',
      transition: theme.transitions.create('opacity'),
      '&:hover': {
        opacity: 1
      },
      // Touch devices
      '@media (hover: none)': {
        opacity: 0,
        visibility: 'hidden'
      },
      '&:disabled': {
        visibility: 'hidden'
      }
    },
    previous: {
      width: '50%',
      left: 0,
      display: 'flex',
      justifyContent: 'flex-start'
    },
    next: {
      width: '50%',
      right: 0,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    arrowIcon: {
      color: theme.palette.text.secondary,
      width: theme.spacing(8),
      height: theme.spacing(8)
    },
    swipeView: {
      height: '100%'
    },
    slide: {
      height: '100%'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var Gallery = function Gallery(_ref) {
  var activeStep = _ref.activeStep,
      classNameProp = _ref.className,
      children = _ref.children,
      ariaLabelPreviousButton = _ref.ariaLabelPreviousButton,
      ariaLabelNextButton = _ref.ariaLabelNextButton,
      onPrevious = _ref.onPrevious,
      onNext = _ref.onNext,
      disablePrevious = _ref.disablePrevious,
      disableNext = _ref.disableNext;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, classNameProp)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disablePrevious,
    "aria-label": ariaLabelPreviousButton,
    className: (0, _classnames["default"])(classes.navButton, classes.previous),
    onClick: onPrevious
  }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowLeft["default"], {
    className: classes.arrowIcon
  })), /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
    containerStyle: {
      height: '100%'
    },
    className: classes.swipeView,
    slideClassName: classes.slide,
    axis: "x",
    index: activeStep,
    onChangeIndex: function onChangeIndex(newIndex) {
      return newIndex < activeStep ? onPrevious() : onNext();
    }
  }, children), /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disableNext,
    "aria-label": ariaLabelNextButton,
    className: (0, _classnames["default"])(classes.navButton, classes.next),
    onClick: onNext
  }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowRight["default"], {
    className: classes.arrowIcon
  })));
};

Gallery.propTypes = {
  /** Accessibility text for previous button */
  ariaLabelPreviousButton: _propTypes["default"].node.isRequired,

  /** Accessibility text for next button */
  ariaLabelNextButton: _propTypes["default"].node.isRequired,

  /** Style applied to the root element */
  className: _propTypes["default"].string,

  /** The content of the component */
  children: _propTypes["default"].node.isRequired,

  /** If `disablePrevious={true}`, the previous button may not be clicked */
  disablePrevious: _propTypes["default"].bool.isRequired,

  /** If `disableNext={true}`, the next button may not be clicked */
  disableNext: _propTypes["default"].bool.isRequired,

  /** The callback fired when the previous button is clicked */
  onPrevious: _propTypes["default"].func.isRequired,

  /** The callback fired when the next button is clicked */
  onNext: _propTypes["default"].func.isRequired
};
var _default = Gallery;
exports["default"] = _default;